<template lang="pug">
    div
        v-expansion-panel
            v-expansion-panel-content(v-for="(item, key) in items" :key="key" hide-actions)
                template(slot="header")
                    div.header
                        div.headerText {{ item.label }}

</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            items: VueTypes.array.def([])
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'
    @import '../../assets/style/_mixins.styl'

    .header
        display: flex
        align-items: center
        font-size: remify(15px)
        color: $theme.white

    .iconWrapper
        background-color: $theme.primary
        width: 10px
        height: 10px
        margin-right: 10px
        display: flex
        transition: background-color 0.2s
        box-shadow: 0 0 14px rgba(255, 255, 255, 0.25)

        .addIcon
            font-size: 10px
            color: $theme.white

    .description
        color: $theme.darkGrey
        padding-bottom: 10px

    >>>
        .v-expansion-panel
            li.v-expansion-panel__container
                background: transparent
                border-color: rgba(255, 255, 255, 0.3)

            .v-expansion-panel__header
                padding: 0
                min-height: 34px
                background-color: transparent
                color: $theme.white

    .v-expansion-panel
            box-shadow: none
            border-width: 0
</style>
